import { LockInfo } from 'src/models/common/LockInfo';
import CONSTANTS from 'src/utils/constants';
import {WorksheetMode} from "src/models/tp-allocation/TPAllocationEnums";

/**
 * Derives the VIEW_MODE value from lock state.
 * If lockInfo is null/undefined (backend doesn't return it or hasn't loaded yet),
 * treats as not locked → READ_ONLY (safe default, Edit button will be enabled).
 */
export function deriveViewModeFromLockInfo(
    lockInfo: LockInfo | undefined | null,
    currentUser: string | undefined,
): string {
    if (!lockInfo) {
        return CONSTANTS.VIEW_MODE.READ_ONLY;
    }
    if (currentUser && lockInfo.lockedBy === currentUser) {
        return CONSTANTS.VIEW_MODE.EDITABLE;
    }
    return CONSTANTS.VIEW_MODE.READ_ONLY;
}

export function isLockedByOther(
    lockInfo: LockInfo | undefined | null,
    currentUser: string | undefined,
): boolean {
    if (!lockInfo) {
        return false;
    }
    return lockInfo.lockedBy !== currentUser;
}

export function getEffectiveViewModeForTPA(parentViewMode: string, worksheetMode: WorksheetMode) {
    // Linked workhseets are not allowed to provide an editable interface for anything other than the placeholder step
    if (parentViewMode == CONSTANTS.VIEW_MODE.EDITABLE && worksheetMode == WorksheetMode.LINKED) {
        return CONSTANTS.VIEW_MODE.READ_ONLY;
    }

    return parentViewMode;
}